module.exports = __webpack_public_path__ + "images/fixItIcon-366b0890695bf205f24e4bd6cee9c62e.svg";